import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { AuthContext } from '../Approutes';

const ProtectedRoutes = () => {
    const { auth } = useContext(AuthContext);

    if (!auth) {
        return <Navigate to={'/login'} replace />
    }
    else {
        return <Outlet />;
    }
}

export default ProtectedRoutes;